<section class="d-flex align-items-center flex-column">
  <ngx-qrcode qrc-element-type="canvas" [elementType]="elementType" [errorCorrectionLevel]="correctionLevel"
    [value]="qrurl" cssClass="bshadow"></ngx-qrcode>
  <div class="qrurl status status-gray">
    <a [href]="qrurl" target="_blank" matTooltip="Open in new tab" matTooltipPosition="right">{{qrurl}}</a>
  </div>
  <button type="button" class="btn btn-link" (click)="downloadQRCode()">Save QR</button>
</section>